import { Inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { ContactItem } from 'src/app/shared/model/contact-item.model';
import { Contact } from 'src/app/shared/model/contact.model';
import { BaseService } from '../base.service';
import { IAppConfig } from '../Config/app-config.model';
import { ApiResponse } from '../../shared/model/apiresponse.model';
@Injectable({
  providedIn: 'root'
})
export class ContactService extends BaseService {
    
  constructor(public _injector: Injector, @Inject('appconfig') private configParam: IAppConfig) {
    super(_injector);
  }
  
  GetProjectContacts(projectId: string): Observable<Contact[]> {
    return this.Get<Contact[]>(`${this.configParam.ApiConfig.API_ENDPOINT}Contact/GetByProjectId/${projectId}`);
  }

  //GetContact(externalContactId: string): Observable<ContactItem> {
  //  return this.Get<ContactItem>(`${this.configParam.ApiConfig.PEOPLEANDORG_API_ENDPOINT}Contact/${externalContactId}?applicationToken=${this.configParam.ApiConfig.PEOPLEORG_TOKEN}`);
  //}

  GetContact(externalContactId: string): Observable<ApiResponse<ContactItem>> {
    return this.Get<ApiResponse<ContactItem>>(`${this.configParam.ApiConfig.SMSEnterPriseApi}Contact/${externalContactId}`);
  }
}
